import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Agreements from "./Agreements";
import EmployerCertificates from "../employer-certificate/EmployerCertificates";
import IncomeStatements from "./IncomeStatements";
import Pension from "./pension/Pension";
import Invoices from "./invoices/Invoices";
import SupplierLedgers from "./SupplierLedgers";
import Customers from "../Customers";
import TermsAndConditions from "./TermsAndConditions";
import Freelancers from "./Freelancers";
import CreatedTimeSheets from "./CreatedTimeSheets";
import HolidayPay from "./holiday-pay/HolidayPay";
import PreliminaryInvoices from "./preliminary-invoices/PreliminaryInvoices";
import { SalaryTabs } from "./salary-notices/salaries/SalaryTabs";
import { WorkedHours } from "./worked-hours/WorkedHours";
import { LOCALES } from "common/constants";

const EconomyView = () => {
  const language = localStorage.getItem("i18nextLng");
  return (
    <Routes>
      <Route
        exact
        path={language === LOCALES.EN_US ? "invoices" : "fakturor"}
        element={<Invoices />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "terms-and-conditions" : "villkor"}
        element={<TermsAndConditions />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "salaries" : "loner"}
        element={<SalaryTabs />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "customers" : "kunder"}
        element={<Customers />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "freelancers" : "frilansare"}
        element={<Freelancers />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "created-time-sheets" : "skapade-tidrapporter"
        }
        element={<CreatedTimeSheets />}
      />
      <Route exact path="created-time-sheets" element={<CreatedTimeSheets />} />

      <Route
        exact
        path={
          language === LOCALES.EN_US ? "preliminary-invoices" : "preliminara-fakturor"
        }
        element={<PreliminaryInvoices />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "supplier-ledgers" : "leverantorsreskontra"}
        element={<SupplierLedgers />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "employer-certificates" : "/arbetsgivarcertifikat"
        }
        element={<EmployerCertificates />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "worked-hours" : "arbetade-timmar"}
        element={<WorkedHours />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "agreements" : "avtal"}
        element={<Agreements />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "incomestatements" : "inkomstredovisningar"}
        element={<IncomeStatements />}
      />
      <Route exact path="pension" element={<Pension />} />
      <Route
        exact
        path={language === LOCALES.EN_US ? "holiday-pay" : "semesterlon"}
        element={<HolidayPay />}
      />
      <Route
        path="*"
        element={
          <Navigate
            to={
              language === LOCALES.EN_US
                ? `/dashboard/economy/invoices?lang=${LOCALES.EN_US}`
                : `/instrumentbrada/ekonomi/fakturor?lang=${LOCALES.SV_SE}`
            }
          />
        }
      />
    </Routes>
  );
};

export default EconomyView;
